import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledError = styled(Box, {
  color: '$error',
});

export const StyledErrorContainer = styled(Box, {
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
